export default "__VITE_ASSET__cfbb3717__"